module.exports = __webpack_public_path__ + "static/media/badge-en.8cf24804.png";